import React from "react";
import "../landing.css";
import styled from "styled-components";
import whiteLogo from "@asset/ces/logo_color_white_text.png";
import AboutUsButton from "../buttons/AboutUsButton";
import MediaKitButton from "../buttons/MediaKitButton";

const LeftTopLogo = styled.img`
  max-width: 385px;
  width: 100%;
  height: auto;
  aspect-ratio: 385/80;
  margin: 0;
  object-fit: contain;

  @media screen and (max-width: 480px) {
    max-width: 220px;
  }
`;

const AboutUs = () => {
  React.useEffect(() => {
    // 모든 이미지 프리로드
    const images = [whiteLogo];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="landing-section-about_us">
      <LeftTopLogo src={whiteLogo} alt="ces_logo" />
      <p className="about_us-subtitle">MINDSAI Co., Ltd</p>
      <p className="about_us-description">
        A Mental Health Service Company Pioneering Biomarker-based Solutions and
        Digital Therapeutics
      </p>
      <div className="brochure__buttons">
        <AboutUsButton
          title={"About Us"}
          onClick={() => {
            const pdfUrl = "/ces/pdf/MINDSAI.pdf";
            const pdfWindow = window.open(pdfUrl, "_blank");
            if (pdfWindow) {
              pdfWindow.focus();
            }
          }}
        />
        <MediaKitButton
          title={"Media Kit"}
          onClick={() => {
            const pdfUrl = "/ces/pdf/MINDSAI.pdf";
            const pdfWindow = window.open(pdfUrl, "_blank");
            if (pdfWindow) {
              pdfWindow.focus();
            }
          }}
        />
      </div>
    </div>
  );
};

export default AboutUs;
